import OrdersTableSectionExpandable from './OrdersTableSectionExpandable';

export default OrdersTableSectionExpandable;
